export default __webpack_public_path__ + "static/media/default.233b54e2.jpg";